<script lang="ts" setup>
const { apiTokens } = useTeamsStore()
const { t } = useI18n()
</script>

<template>
  <BaseQuote
    size="sm"
    :text="t(apiTokens.length ? 'selectToken' : 'noTokens')"
  />
</template>

<i18n lang="json">
{
  "en": {
    "noTokens": "It seems you don't have any API tokens yet. You can create one in the following block.",
    "selectToken": "Since you already have at least one API token, you can use to authenticate your requests."
  },
  "es": {
    "noTokens": "Parece que no tienes ningún token API todavía. Puedes crear uno en el siguiente bloque.",
    "selectToken": "Puesto que ya tienes al menos un token API, puedes usarlo para autenticar tus solicitudes."
  },
  "fr": {
    "noTokens": "Il semble que vous n'ayez pas encore de jetons API. Vous pouvez créer un jeton dans le bloc suivant.",
    "selectToken": "Puisque vous avez déjà au moins un jeton API, vous pouvez l'utiliser pour authentifier vos requêtes."
  }
}
</i18n>
